module.exports = __webpack_public_path__ + "img/95.8bde62b8.jpg";